import DashboardStore from "../DashboardStore";
import React, { FC, useEffect, useState } from "react";
import { NavigateFunction } from "react-router-dom";
import RecentCustomerIcon from "../../../../../../images/common/user-blue.svg";
import { AuthService, DashboardService } from "../../../shared/services";
import {
  FlexContainer,
  ITableHeaders,
  Loader,
  SapphireBlueButton,
  ToastService,
  UtilityMethods,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import { ContactReferenceModel } from "../../../shared/models";
import { TableGrid } from "../../../shared/components";

type IProps = {
  dashboardStore: DashboardStore;
  navigate: NavigateFunction;
};
const RecentCustomersWidget: FC<IProps> = ({ dashboardStore, navigate }) => {
  const [showLoader, setLoader] = useState(true);
  useEffect(() => {
    DashboardService.getRecentCustomersActivity(
      AuthService.authData.accountId
    ).subscribe({
      next: (response) => {
        setLoader(false);
        const details = response.result.map((item: any) =>
          ContactReferenceModel.deserializeAPIModel(item)
        );
        dashboardStore.updateCustomers(details);
      },
      error: () => {
        ToastService.showError("Error Occured");
      },
    });
  }, []);

  if (showLoader) return <>{new Loader(true, "", "390px").loaderComponent}</>;
  function columns() {
    const columns: ITableHeaders<ContactReferenceModel>[] = [
      {
        dataKey: "firstName",
        title: "Name",
        cellColor: "#556bb8",
        cellClassName: "clickable table-col-50",
        className: "table-col-50",
        onCellRender: (data: ContactReferenceModel) => {
          return (
            <span onClick={() => navigate(`/app/contacts/detail/${data.id}`)}>
              {data.fullName || data.email}
            </span>
          );
        },
      },
      {
        dataKey: "firstName",
        title: "Source",
        cellClassName: "clickable",
        onCellRender: (data: ContactReferenceModel) => {
          return (
            <span onClick={() => navigate(`/app/contacts/detail/${data.id}`)}>
              {data.fullName || data.email}
            </span>
          );
        },
      },

      {
        dataKey: "createdDate",
        title: "Created",
        onCellRender: (data: ContactReferenceModel) => {
          return UtilityMethods.formatDateInStringWithTime(data.createdDate);
        },
      },
    ];
    return columns;
  }

  if (showLoader || !dashboardStore.customersWidgetData) {
    return <> {new Loader(true, "", "390px").loaderComponent}</>;
  }
  return (
    <>
      <FlexContainer
        justifyContent="space-between"
        className="activity-header-wrapper"
      >
        <div>
          <FlexContainer
            alignItems="center"
            spacing={10}
            padding="0px 0px 30px"
          >
            <img src={RecentCustomerIcon} />
            <div className="activity-card-header"> Recent Customers</div>
          </FlexContainer>
        </div>
        <div>
          <SapphireBlueButton>View</SapphireBlueButton>
        </div>
      </FlexContainer>
      <TableGrid
        totalItemCount={0}
        cellSpacing={20}
        data={dashboardStore.customersWidgetData || []}
        headers={columns()}
        className="recent-customer-table db-payment-plh"
      />
    </>
  );
};
export default withRouter(RecentCustomersWidget);
